import { CommonModule } from '@angular/common'
import { Component, input, output } from '@angular/core'

import { OptimUiSharedModule } from '../../shared/optimus-ui-shared.module';
@Component({
  standalone: true,
  imports: [OptimUiSharedModule, CommonModule],
  selector: 'app-aside',
  templateUrl: './aside.component.html',
  styleUrls: ['./aside.component.scss']
})
export class AsideComponent {
  readonly fixed = input(false)
  readonly display = input(false)
  readonly closed = output<void>()
}
